module.exports = __webpack_public_path__ + "static/planes@2x-a7a1df0a0675784c5eea62c76fd88346.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/pop/share/planes@2x.png
// module id = 925
// module chunks = 37722542382512 271422636699454